export default {
    RESET_WORKER_DETAIL(state) {
        state.workerDetail = null;
    },
    GET_WORKER_DETAIL(state, payload) {
        state.workerDetail = payload;
    },
};
